<template>
    <ol class="breadcrumb p-0 m-0">
        <li v-for="i in treeData" :key="i.id" class="breadcrumb-item">
            {{ i.label }}
        </li>
    </ol>
</template>

<script>
import TreeComponentMixin from "./TreeComponentMixin.js";

export default {
    name: "OTreeBreadcrumbs",
    mixins: [TreeComponentMixin],
    props: {},
    data() {
        return {
            treeOptions: {
                selectable: true,
                checkboxes: true,
            },
        };
    },
    methods: {},
};
</script>
<style scoped>
ol {
    background-color: transparent;
}
</style>
